import { QUERY_SEARCH_PARAM_PAGE } from '~/features/catalog/mappers/catalogSearchQueryMapper.ts';
import { sortSearchParams } from '~/common/utils/urlUtil.ts';

export const CATALOG_SEARCH_KEY = 'catalog-search';
export function buildCatalogSearchQuery(pathName: string, query: URLSearchParams) {
  if (!query.has(QUERY_SEARCH_PARAM_PAGE)) {
    query.set(QUERY_SEARCH_PARAM_PAGE, '0');
  }

  return [CATALOG_SEARCH_KEY, pathName, sortSearchParams(query).toString()];
}
